<template>
  <div class="top_wrapper">
    <div class="password_change" v-if="password_change">
      パスワードが２ヶ月変更されておりません。安全性のため、変更お願い致します。
    </div>
    <div class="whatnew_message u-mt--10" v-if="whatsNewText">{{ whatsNewText }}</div>
    <div class="add_user" v-if="showCredit">
      <a href="#" v-on:click.prevent="application('credit')">
        カード発行申し込み（信販）
        <i class="el-icon-bank-card"></i>
      </a>
    </div>
    <div class="add_cregit" v-if="showInstallment">
      <a href="#" v-on:click.prevent="application('installment')">
        信用保証申し込み（自社割賦）
        <i class="far fa-handshake"></i>
      </a>
    </div>
    <el-divider v-if="isBranch"></el-divider>
    <div class="second" :class="{'u-mt--24': !isBranch}">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="6" class="list" style="touch-action: manipulation">
          <a href="#" @click.prevent="list"> ご契約情報一覧<i class="fas fa-list-ul"></i> </a>
        </el-col>
        <el-col :span="6" class="list" style="touch-action: manipulation">
          <a href="#" @click.prevent="passwordReset"> パスワード変更<i class="fas fa-pencil-alt"></i> </a>
        </el-col>
        <el-col :span="6" class="list" style="touch-action: manipulation">
          <a href="#" @click.prevent="documentDownload"> 各種書類<span>※口座振替依頼書、解約書式等</span><i class="el-icon-document"></i> </a>
        </el-col>
      </el-row>
    </div>
    <div class="contact_box">
      <p class="contact_box__basic_text contact_box__basic_text--bold">トリプルクラウン</p>
      <p class="contact_box__basic_text contact_box__basic_text--bold">お申込みに関するお問い合わせ先</p>
      <p class="contact_box__basic_text contact_box__basic_text--bold">TEL 092-292-7544</p>
      <el-row :gutter="20" type="flex" justify="center" align="middle">
        <el-col :span="11" class="text-right">
          <p class="contact_box__basic_text">営業時間</p>
        </el-col>
        <el-col :span="13" class="text-left">
          <p class="contact_box__basic_text">
            平　日 9:00〜19:00<br />
            <!-- 土曜日 9:00〜18:00<br />
            日曜・祝日　休業 -->
            土曜日・日曜・祝日　休業
          </p>
        </el-col>
      </el-row>
      <p class="contact_box__basic_text">※解約に関するお問い合わせは、平日のみの対応となります。</p>
    </div>
    <el-divider></el-divider>
    <h3 class="whatnew_title"><i class="fas fa-info-circle"></i> TripleCrownからのお知らせ</h3>
    <div class="block">
      <el-timeline>
        <el-timeline-item v-for="(item, index) in news" :key="index" :timestamp="item.timestamp" placement="top">
          <el-card>
            <h4><span v-if="item.isNew" class="whatnew_new">new</span> {{ item.title }}</h4>
            <p v-html="changeLink(item.message)"></p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {mapGetters, mapActions} from 'vuex'
import {nl2br} from '../../util/helper'

export default {
  name: 'top',
  data() {
    return {
      password_change: false,
      news: [],
      aplusForm : {
        url: '',
        aplusCode: '',
      }
    }
  },
  created() {
    history.pushState(null, null, null)
  },
  mounted() {
    this.$store.state.hasCancel = false
    this.$store.state.login_page = false

    // パスワード変更の通知
    const user = this.$store.state.auth.user
    const pass_change = moment(user.password_change_at)
    if (moment().diff(pass_change, 'days') > 60) {
      this.password_change = true
    }

    // ニュースの表示
    axios.get('/api/store/news/list').then((res) => {
      let news_list = []
      for (let key in res.data) {
        let array = res.data
        let news = {
          timestamp: '',
          title: '',
          message: '',
          isNew: false
        }
        news.timestamp = moment(array[key].publish_at).format('YYYY/MM/DD')
        news.title = array[key].title
        news.message = nl2br(array[key].content)
        news.isNew = moment().diff(news.timestamp, 'days') < 7
        news_list.push(news)
      }
      this.news = news_list
    })
  },
  methods: {
    application(status) {
      this.deleteStore()
      this.updateHasPayment(status)
      this.updateHasRegistration('new')
      this.transitionSame('form-product-input')
    },
    list() {
      this.transitionSame('list')
    },
    passwordReset() {
      this.transitionSame('password-reset')
    },
    documentDownload() {
      this.transitionSame('document-download')
    },
    //Storeの本人情報と商品情報の初期化
    deleteStore() {
      this.userInputInitForm()
      this.productInputInitForm()
      this.productInputUpdateValidations([])
      this.userInputUpdateValidations([])
    },
    changeLink(text) {
      return _.isString(text)
        ? text.replace(/(http(s)?:\/\/[a-zA-Z0-9-.!'()*;/?:@&=+$,%#\[\]_]+)/gi, "<a href='$1' target='_blank'>$1</a>")
        : ''
    },
    downloadListExcel(scope) {
      const url = `/api/admin/contract/${scope}/downloadExcel`
      const parmStr = new URLSearchParams(this.searchParams).toString()
      location.href = url + '?' + parmStr
    },
    ...mapActions({
      productInputInitForm: 'productInput/initForm',
      productInputUpdateValidations: 'productInput/updateValidations',
      userInputInitForm: 'userInput/initForm',
      userInputUpdateValidations: 'userInput/updateValidations',
      updateHasPayment: 'status/updateHasPayment',
      updateHasRegistration: 'status/updateHasRegistration'
    }),
  },
  computed: {
    ...mapGetters({
      isBranch: 'auth/isBranch',
      isStore: 'auth/isStore'
    }),
    showCredit() {
      if (this.isStore) {
        return false
      }
      const user = this.$store.state.auth.user
      return user.credit_serviceable
    },
    showInstallment() {
      if (this.isStore) {
        return false
      }
      const user = this.$store.state.auth.user
      return user.installment_serviceable
    },
    whatsNewText() {
      if (!this.news.length) return ''

      const newArticle = this.news.find((n) => n.isNew)
      if (!newArticle) return ''

      const days = moment(newArticle.timestamp).format('MM/DD') ?? ''
      return `※${days} 新着お知らせを更新しました。ご確認ください。※`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.add_user,
.add_cregit {
  text-align: center;
  a {
    position: relative;
    display: inline-block;
    padding: 20px;
    width: 77%;
    max-width: 600px;
    border-radius: 10px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
    font-size: 27px;
    line-height: 1.2;
    span {
      font-size: 16px;
      font-weight: bold;
    }
    i {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 40px;
      font-size: 36px;
    }
  }
}
.add_user {
  margin-top: 30px;
}
.add_cregit {
  padding-bottom: 20px;
  margin-top: 20px;
}
.list {
  text-align: center;
  min-width: 200px;
  height: 96px;
  a {
    position: relative;
    display: inline-block;
    width: 100%;
    border-radius: 10px;
    border: 1px solid $--color-second;
    color: $--color-second;
    font-size: 20px;
    line-height: 1.2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include mq-down(xs) {
      font-size: 15px;
    }
    span {
      display: block;
      font-size: 12px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 12px;
    }
    i {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 30px;
      font-size: 28px;
      @include mq-down(xs) {
        font-size: 20px;
      }
      @include mq-down(lg) {
        left: 20px;
      }
    }
  }
}
.whatnew_title {
  font-weight: bold;
  color: $--color-primary;
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.whatnew_new {
  display: inline-block;
  border-radius: 5px;
  font-size: 14px;
  padding: 3px 10px;
  vertical-align: top;
  line-height: 1;
  border: 1px solid #ffa5a5;
  background-color: rgb(255, 230, 0);
  text-align: center;
  color: red;
}
.el-timeline {
  padding-left: 0;
}
.el-card__body {
  p {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
.password_change {
  padding: 10px;
  border: 1px solid #ffa5a5;
  background-color: #ffe6e6;
  text-align: center;
  color: red;
  font-weight: bold;
  border-radius: 5px;
}
.whatnew_message {
  padding: 10px;
  border: 1px solid #ffa5a5;
  background-color: rgb(255, 230, 0);
  text-align: center;
  color: red;
  font-weight: bold;
  border-radius: 5px;
}
.contact_box{
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  border: 1px solid #000;
  background-color: #FFFFE7;
  max-width: 500px;
  text-align: center;
  &__basic_text{
    margin: 0;
    font-size: 14px;
    &--bold{
      font-weight: bold;
    }
  }
}
</style>
